
import languages from './languages';
import tours from './tours';

const exports = {
    languages,
    tours,
};

export default exports
